import type { z } from "zod";

import { UserEntity } from "~/entities/user/@x/auth";

const zIn = UserEntity.zSchema.pick({
  email: true,
});
type In = z.infer<typeof zIn>;

export { zIn };
export type { In };
